import client from 'integration/client'

import { BannerImageData } from './types'

export const getBannerImages = () => client.get<BannerImageData>(`v1/banner-images/`)
